import { eur } from "@/lib/apiClient";

const k = (n) => `${Math.round(n / 1000)}k`;

// Confronto tra combinazioni dello stesso livello RC/diarie; un clic ricalcola sulla combinazione scelta.
export const MrvConfronto = ({ rows, onPick, disabled }) => {
  if (!rows || rows.length < 2) return null;
  return (
    <div className="rounded-lg border border-border p-3" data-testid="mrv-confronto">
      <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-forest">Confronta le combinazioni</div>
      <div className="space-y-1.5">
        {rows.map((r) => (
          <button key={r.code} disabled={disabled || r.corrente} onClick={() => onPick(r.code)} data-testid={`mrv-confronto-${r.code}`}
            className={`flex w-full items-center justify-between rounded-lg border px-3 py-2 text-left text-xs transition-colors ${r.corrente ? "border-forest bg-forest text-white" : "border-border text-forest hover:bg-sage"}`}>
            <span><b>Comb. {r.code}</b> · Morte {k(r.morte)} / IP {k(r.ip)}</span>
            <span className="font-semibold">{r.premio != null ? eur(r.premio) : "—"}</span>
          </button>
        ))}
      </div>
      <div className="mt-1.5 text-[11px] text-muted-foreground">Stesse diarie e spese mediche, premio di tariffa o minimo D998. Clic per passare alla combinazione.</div>
    </div>
  );
};
